import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getResolvedStepRequest = {};
var _getResolvedStepResponse = { resolvedStep: '_resolvedStep' };
var _listResolvedStepsRequest = {};
var _listResolvedStepsResponse = { resolvedSteps: '_resolvedStep' };
var _queryResolvedStepsRequest = {};
var _queryResolvedStepsResponse = { resolvedSteps: '_resolvedStep' };
var _resolvedStep = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _resolveStepRequest = {};
var _resolveStepResponse = { resolvedStep: '_resolvedStep' };
var _undoStepRequest = {};
var _undoStepResponse = {};
function resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/participants-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Resolve program step */
export function resolveStep(payload) {
    var _a = serializer(_resolveStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_resolveStepResponse, {
        _resolvedStep: _resolvedStep,
    }).fromJSON;
    function __resolveStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.resolved_step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ResolvedStepsService.ResolveStep',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl({
                protoPath: '/v3/participants/{participantId}/steps/{stepId}/resolve',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resolveStep.fromReq = fromReq;
    __resolveStep.__isAmbassador = true;
    return __resolveStep;
}
/** Undo resolved step */
export function undoStep(payload) {
    var _a = serializer(_undoStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_undoStepResponse, {}).fromJSON;
    function __undoStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.resolved_step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ResolvedStepsService.UndoStep',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl({
                protoPath: '/v3/participants/{participantId}/steps/{stepId}/undo',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __undoStep.fromReq = fromReq;
    __undoStep.__isAmbassador = true;
    return __undoStep;
}
/** List resolved steps by participant */
export function listResolvedSteps(payload) {
    var _a = serializer(_listResolvedStepsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listResolvedStepsResponse, {
        _resolvedStep: _resolvedStep,
    }).fromJSON;
    function __listResolvedSteps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.resolved_step',
            method: 'GET',
            methodFqn: 'wix.onlineprograms.participants.v3.ResolvedStepsService.ListResolvedSteps',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl({
                protoPath: '/v3/participants/{participantId}/steps',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listResolvedSteps.fromReq = fromReq;
    __listResolvedSteps.__isAmbassador = true;
    return __listResolvedSteps;
}
/** Get resolved steps */
export function getResolvedStep(payload) {
    var _a = serializer(_getResolvedStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getResolvedStepResponse, {
        _resolvedStep: _resolvedStep,
    }).fromJSON;
    function __getResolvedStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.resolved_step',
            method: 'GET',
            methodFqn: 'wix.onlineprograms.participants.v3.ResolvedStepsService.GetResolvedStep',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl({
                protoPath: '/v3/participants/{participantId}/steps/{stepId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getResolvedStep.fromReq = fromReq;
    __getResolvedStep.__isAmbassador = true;
    return __getResolvedStep;
}
/** Query resolved steps */
export function queryResolvedSteps(payload) {
    var _a = serializer(_queryResolvedStepsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryResolvedStepsResponse, {
        _resolvedStep: _resolvedStep,
    }).fromJSON;
    function __queryResolvedSteps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.resolved_step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ResolvedStepsService.QueryResolvedSteps',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl({
                protoPath: '/v3/participants/steps/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryResolvedSteps.fromReq = fromReq;
    __queryResolvedSteps.__isAmbassador = true;
    return __queryResolvedSteps;
}
//# sourceMappingURL=http.impl.js.map